import React, { useEffect, useState } from "react";
import { cx, css } from "emotion";
import moment from "moment";
import { Card, Heading, Link, Icon } from "@maxmilhas/hangar-components-atomic/public";
import { headingHotels, linkPartners } from "./style";
import { green } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

const HotelsWidget = ({ trip }) => {
    const { flights, order } = trip;
    const {from, cabin} = flights.outbound;
    const destinationIata = flights.outbound.to;
    const purchaseDate = order.purchaseDate.split(" ")[0];
    let checkin = flights.outbound.arrivalDate.split(" ")[0];
    let checkout = flights.inbound && flights.inbound.departureDate && flights.inbound.departureDate.split(" ")[0];
    checkin = moment(checkin, "DD-MM-YYYY").format('YYYY-MM-DD');
    checkout = checkout ? moment(checkout, "DD-MM-YYYY").format('YYYY-MM-DD') : moment(checkin).add(1, "days").format("YYYY-MM-DD");
    const isAPastFlight = moment.now() > moment(checkin);
    const url = `https://widgets.hotels.com/getXsellWidget?airportDeparture=${from}&airportArrival=${destinationIata}&outboundDate=${checkin}&inboundDate=${checkout}&purchaseDate=${purchaseDate}&flightClass=${cabin === 'EC' ? 'Economy' : 'Business'}&widgetType=MB&widgetID=122&wapb3=|c.605212|l.pt_BR|t.site|s.my_tips_widget&utm_source=maxmilhas&utm_medium=site_my_trips_widget`;

    return (
        !isAPastFlight &&
        <Card>
            <div
                className={css`
					${headingHotels}
				`}
            >
                <Heading tag="h6">Reserve seu Hotel</Heading>
                <div
                    className={cx(
                        css`
							${linkPartners}
						`,
                        "hidden-xs"
                    )}
                >
                    <Link href="https://www.maxmilhas.com.br/blog/parceiros-maxmilhas" target="_blank">
                        Ver todos os parceiros
					</Link>
                    <Icon name="icon-max-navigation-arrow-down" size="small" color={green}></Icon>
                </div>
            </div>
            <iframe id="hotels-iframe" referrerPolicy="no-referrer" src={url} allow="geolocation" scrolling="no" frameBorder="0" width="100%" height="520" title="hotel deals" style={{ overflow: 'hidden', border: '0px', margin: '0px', padding: '0px', height: '520px', width: '100%', transition: 'height 0.3s ease-in-out 0s' }}></iframe>
            <div
                className={cx(
                    css`
						${linkPartners}
					`,
                    "hidden-sm hidden-md hidden-lg"
                )}
            >
                <Link href="https://www.maxmilhas.com.br/blog/cupom-desconto-maxmilhas" target="_blank">
                    Ver todos os parceiros
				</Link>
                <Icon name="icon-max-navigation-arrow-down" size="small" color={green}></Icon>
            </div>
        </Card>
    );
};

export default HotelsWidget;
